import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "form", "delta", "reason"];

  open(event) {
    const url = event.currentTarget.dataset.creditAdjustUrlValue;
    if (url) {
      this.formTarget.action = url;
    }
    this.deltaTarget.value = "";
    this.reasonTarget.value = "";
    this.modalTarget.classList.remove("hidden");
  }

  close() {
    this.modalTarget.classList.add("hidden");
  }
}
